"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInput = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
const HiddenInput = _ref => {
  let {
    clientId,
    hiddenInputName,
    getHiddenInputValue,
    selectionType
  } = _ref;
  const [hiddenInputValue, setHiddenInputValue] = (0, _react.useState)(undefined);
  (0, _react.useEffect)(() => {
    if (getHiddenInputValue && selectionType) {
      setHiddenInputValue(getHiddenInputValue(selectionType));
    }
  }, [selectionType, getHiddenInputValue]);
  const shouldRender = hiddenInputName && hiddenInputValue !== undefined;
  return shouldRender ? /*#__PURE__*/_react.default.createElement("input", {
    name: hiddenInputName,
    value: hiddenInputValue,
    hidden: true,
    readOnly: true,
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "-hidden-input")
  }) || null : null;
};
exports.HiddenInput = HiddenInput;
//# sourceMappingURL=HiddenInput.js.map